<div class="aems-card m-b-12">
  <p class="mds-content"><strong>Operational Settings</strong></p>
  <hr class="m-b-12" />
  <div style="display: flex; gap: 16px; flex-wrap: wrap">
    @if (partsManagementOperationalSettings.isSerialTagNumberRequired) {
      <mc-tag fit="large" appearance="info" label="Serial TAG Number Required : Yes"></mc-tag>
    } @else {
      <mc-tag fit="large" label="Serial TAG Number Required : No"></mc-tag>
    }
    @if (partsManagementOperationalSettings.deductCore) {
      <mc-tag fit="large" appearance="info" label="Deduct Core Value : Yes"></mc-tag>
    } @else {
      <mc-tag fit="large" label="Deduct Core Value : No"></mc-tag>
    }
    @if (partsManagementOperationalSettings.isActive) {
      <mc-tag fit="large" appearance="info" label="Active : Yes"></mc-tag>
    } @else {
      <mc-tag fit="large" label="Active : No"></mc-tag>
    }
  </div>
</div>
